var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"non-bind-mask"},[_c('div',{staticClass:"mask-content"},[_c('img',{attrs:{"src":require("@/assets/qualificationQuery/vip_icon.png"),"alt":""}}),_c('p',[_vm._v("您尚未登录账号，请登录后进行查看")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n\t\t\t立即登录\n\t\t\t"),_c('i',{staticClass:"el-icon-arrow-right"})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }